module.exports = __webpack_public_path__ + "static/img/setting.03726a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/setting.png
// module id = V62w
// module chunks = 24